import { render, staticRenderFns } from "./TabOther.vue?vue&type=template&id=12c0b6a0"
import script from "./TabOther.vue?vue&type=script&lang=js"
export * from "./TabOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports